export const GLOBAL_OPENER_DELAY = 1.2;
